/**
 * Purchase Manager Analytics - Constants & Default Configuration
 */
import { AnalyticsConfig } from '../models/analytics.interfaces';

export const ANALYTICS_STORAGE_KEY = 'pm_analytics';
export const ANALYTICS_SESSION_KEY = 'pm_analytics_session';
export const ANALYTICS_VERSION = 1;

/**
 * Default analytics configuration.
 * Override per-environment in environment.ts → analyticsConfig.
 */
export const DEFAULT_ANALYTICS_CONFIG: AnalyticsConfig = {
    storageKeyPrefix: 'pm_analytics',
    maxPendingEvents: 500,
    maxFailedEvents: 100,
    syncIntervalMs: 10 * 1000, // 10 seconds (temporary for testing)
    maxConsecutiveFailures: 5,
    backoffMultiplier: 2,
    maxStorageSizeBytes: 2 * 1024 * 1024, // 2 MB
    maxRetryCount: 3,
    debugMode: false,
    syncEndpoint: 'purchase-manager/analytics/sync',
    batchSize: 50,
    cartAbandonTimeoutMs: 10 * 60 * 1000, // 10 minutes
};

/**
 * Supplier display mapping for analytics labels.
 */
export const SUPPLIER_LABELS: Record<string, string> = {
    hyperpure: 'Hyperpure',
    udaan: 'Udaan',
    dmart: 'DMart',
    local: 'Local Supplier',
};

/**
 * Funnel stage ordering (index = progression).
 */
export const FUNNEL_STAGE_ORDER = [
    'landing',
    'search',
    'results',
    'cart_add',
    'cart_view',
    'checkout',
    'proceed_to_buy',
    'create_po',
    'generate_po',
    'complete',
] as const;
